<template>
	<div>
		<b-modal ref="delete-modal" title="Delete item" @ok.prevent="deleteItem()">
			<span v-if="id">Are you sure you want to delete category {{id}}?</span>
			<b-alert variant="danger" :show="!!saveError">{{saveError}}</b-alert>
			<template #modal-footer="{ok, cancel}">
				<b-spinner v-show="saving" small label="Spinning"></b-spinner>
				<b-button size="sm" variant="danger" @click="ok()">Delete</b-button>
				<b-button size="sm" @click="cancel()">Cancel</b-button>
			</template>
		</b-modal>
	</div>
</template>
<script>
export default {
	name: 'CategoryDeleteModal',
	data() {
		return {
			id: null,
			saving: false,
			saveError: null,
		}
	},
	methods: {
		show(id) {
			this.id = id;
			this.saveError = null;
			this.saving = false;
			this.$refs['delete-modal'].show();
		},
		deleteItem() {
			this.saving = true;
			this.saveError = null;
			this.$api.delete('category', { id: this.id }).then(() => {
				this.saving = false;
				this.saveError = null;
				this.$refs['delete-modal'].hide();
				this.$bvToast.toast('Deleted category', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
				this.$emit('deleted');
			}, err => {
				this.saveError = err && err.error || err.toString();
				this.saving = false;
				console.error('Error deleting category:', err);
			});
		}
	}
}
</script>
